<div id="cover" *ngIf="projectService.loading()"></div>

<div class="config-wrapper">
  <div class="card-ui form-master-card">
    <div class="card-body">
      <div class="form-master-header">
        <div class="form-field-group">
          <label>Select Form</label>
          <p-select [options]="formList" optionLabel="form_name" optionValue="form_id" [(ngModel)]="selectedForm"
            (onChange)="onFormChange()" appendTo="body" [showClear]="true" [resetFilterOnHide]="true"
            [style]="{ width: '100%' }" placeholder="-- Select Form --">
          </p-select>
        </div>
        <div class="form-field-group">
          <label>Form Name <span class="required-star">*</span></label>
          <input type="text" class="custom-input" [(ngModel)]="formName" (ngModelChange)="updateFormName($event)"
            placeholder="Form name">
        </div>
        <div class="form-field-group add-section-group">
          <button class="btn-primary-save" (click)="addSection()" [disabled]="!formName">
            <i class="fas fa-plus"></i> Add Section
          </button>
        </div>
        <div class="right-actions">
          <div class="status-badge">
            <span class="status-label">Status:</span>
            <p-toggleSwitch id="is_active" [(ngModel)]="isActive"></p-toggleSwitch>
          </div>
          <div class="status-badge">
            <span class="status-label">Report Formula Configuration 𝑓(𝑥):</span>
            <p-toggleSwitch [(ngModel)]="showReportConfig"></p-toggleSwitch>
          </div>
          <button class="btn-danger-delete" (click)="onDeleteForm()">
            <i class="fas fa-trash-alt"></i>
            <span class="ml-2">Delete Form</span>
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="card-ui sections-card" *ngIf="sections.controls.length > 0">
    <div class="tabs-container">
      <div class="tab-headers">
        <div *ngFor="let section of sections.controls; let i = index; trackBy: trackBySection" class="tab-item"
          [class.active]="activeTabIndex === i" (click)="setActiveTab(i)">
          <span class="tab-title">{{ getSectionName(section, i) }}</span>
          <button class="tab-close" (click)="removeSection(i, $event)">
            <i class="fas fa-times"></i>
          </button>
        </div>
      </div>

      <div class="tab-panels">
        <div *ngFor="let section of sections.controls; let i = index; trackBy: trackBySection" class="tab-panel"
          [class.active-panel]="activeTabIndex === i">
          <div class="section-settings">
            <div class="settings-row">
              <div class="settings-field">
                <input type="text" class="custom-input" [ngModel]="section.get('section_name')?.value"
                  (ngModelChange)="onSectionNameChange($event,i)" placeholder="Section Name">
              </div>
              <div class="settings-field">
                <p-select [options]="layoutTypeOptions" optionLabel="label" optionValue="value"
                  [ngModel]="section.get('layout_type')?.value"
                  (ngModelChange)="section.get('layout_type')?.setValue($event); onLayoutChange(i)"
                  [style]="{ width: '100%' }" placeholder="Select Layout" appendTo="body">
                </p-select>
              </div>
              <div class="settings-field" *ngIf="section.get('layout_type')?.value === 'Matrix'">
                <p-select [options]="rowCalcOptions" optionLabel="label" optionValue="value"
                  [ngModel]="section.get('row_calculation')?.value"
                  (ngModelChange)="section.get('row_calculation')?.setValue($event)" [style]="{ width: '100%' }"
                  placeholder="Row Calculation" appendTo="body">
                </p-select>
              </div>
              <div class="settings-field master-field" *ngIf="section.get('layout_type')?.value === 'Matrix'">
                <p-multiSelect [options]="masterTypes" optionLabel="master_type_name" optionValue="master_type_id"
                  [(ngModel)]="masterTypeSelections[i]" (onChange)="onMasterTypeChange(i)" [showHeader]="true"
                  [filter]="true" filterPlaceholder="Search..." [style]="{width: '100%'}" placeholder="Master Types"
                  appendTo="body">
                </p-multiSelect>
              </div>
            </div>
          </div>
          <div class="two-column-layout">
            <div class="col-card col-left">
              <div class="card-header-flex">
                <span class="section-icon"><i class="fas fa-up-down"></i> Columns</span>
                <button style="padding: 0px 20px !important" class="btn-primary-save" (click)="addField(i)">
                  <i class="fas fa-plus"></i> Add
                </button>
              </div>
              <div class="fields-list-container">
                <div class="fields-list">
                  <div *ngFor="let field of getSectionFields(i).controls; let j = index; trackBy: trackByField"
                    class="field-item">
                    <div class="field-row-inline">
                      <div class="field-label">
                        <input type="text" class="custom-input" [ngModel]="field.get('field_label')?.value"
                          (ngModelChange)="field.get('field_label')?.setValue($event)" placeholder="Label">
                      </div>
                      <div class="field-type">
                        <p-select [options]="dataTypeOptions" optionLabel="label" optionValue="value"
                          [ngModel]="field.get('field_type')?.value"
                          (ngModelChange)="field.get('field_type')?.setValue($event); onFieldTypeChange(i, j)"
                          [style]="{ width: '100%' }" placeholder="Select Type" appendTo="body">
                        </p-select>
                      </div>
                      <div class="field-master" *ngIf="field.get('field_type')?.value === 'Dropdown'">
                        <p-select [options]="subMasterList" optionLabel="master_value_name"
                          optionValue="master_value_id" [ngModel]="field.get('master_value_id')?.value"
                          (ngModelChange)="field.get('master_value_id')?.setValue($event)" [style]="{ width: '100%' }"
                          placeholder="Select Master" appendTo="body">
                        </p-select>
                      </div>
                      <div class="field-label" style="min-width: 60px !important; max-width: 60px !important;">
                        <input type="number" class="custom-input" [ngModel]="field.get('field_index_id')?.value"
                          (ngModelChange)="field.get('field_index_id')?.setValue($event)" placeholder="Column Order">
                      </div>
                      <div class="field-actions-compact">
                        <label class="check-label-compact" title="Summable">
                          <input class="custom-input" type="checkbox" [ngModel]="field.get('is_column_summable')?.value"
                            (ngModelChange)="field.get('is_column_summable')?.setValue($event)">
                          <span>Summary</span>
                        </label>
                        <label class="check-label-compact" title="Required">
                          <input class="custom-input" type="checkbox" [ngModel]="field.get('is_required')?.value"
                            (ngModelChange)="field.get('is_required')?.setValue($event)">
                          <span>Required</span>
                        </label>
                      </div>
                      <button class="row-delete-btn" (click)="removeField(i, j)">
                        <i class="fas fa-trash"></i>
                      </button>
                    </div>
                  </div>
                  <div *ngIf="getSectionFields(i).controls.length === 0" class="empty-placeholder">
                    No columns added
                  </div>
                </div>
              </div>
            </div>
            <div class="col-card col-right">
              <div *ngIf="section.get('layout_type')?.value === 'Matrix'">
                <div class="card-header-flex">
                  <span class="section-icon"><i class="fas fa-left-right"></i> Rows</span>
                </div>
                <div class="rows-list-container">
                  <div class="rows-grid">
                    <div *ngFor="let row of getSectionRows(i).controls; let r = index; trackBy: trackByRow"
                      class="row-card">
                      <div class="row-card-header">
                        <div class="row-card-title">
                          <i class="fas fa-grip-vertical"></i>
                          {{ getMasterTypeName(row.get('master_type_id')?.value) || 'Row ' + (r + 1) }}
                        </div>
                        <button class="row-delete-btn" (click)="removeRow(i, r)">
                          <i class="fas fa-trash"></i>
                        </button>
                      </div>
                      <div class="row-card-body">
                        <div class="row-form-group">
                          <p-multiSelect [options]="getMastersByType(row.get('master_type_id')?.value)"
                            optionLabel="master_value_name" optionValue="master_value_id"
                            [ngModel]="getRowMasterValues(i, r)" (ngModelChange)="setRowMasterValues(i, r, $event)"
                            [showHeader]="true" [filter]="true" filterPlaceholder="Search..."
                            placeholder="Select Masters" appendTo="body" class="row-multiselect">
                          </p-multiSelect>
                          <div class="selected-values-list" *ngIf="getRowMasterValues(i, r).length > 0">
                            <div class="selected-value-card" *ngFor="let masterValueId of getRowMasterValues(i, r)">
                              <span class="selected-value-label">
                                {{ getMasterValueName(row.get('master_type_id')?.value, masterValueId) }}
                              </span>
                              <div class="operator-btn-group">
                                <button type="button" *ngFor="let op of operatorList" class="operator-btn"
                                  [class.active]="getRowOperatorValue(i, r, masterValueId) === op.value"
                                  [title]="op.label" (click)="setRowOperatorValue(i, r, masterValueId, op.value)">
                                  {{ op.value }}
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div *ngIf="getSectionRows(i).controls.length === 0" class="empty-placeholder">
                      No rows configured
                    </div>
                  </div>
                </div>
                <div class="rows-summary-title">
                  <div style="padding: 5px 20px; display: flex; gap: 20px;">
                    <label class="row-card-title"> Σ Summary Row Title <span
                        style="color: rgb(134, 134, 134); text-transform: capitalize;">(Optional)</span>
                    </label>
                    <input type="text" class="custom-input-summary" [ngModel]="section.get('summary_row_label')?.value"
                      (ngModelChange)="section.get('summary_row_label')?.setValue($event)" placeholder=" ">
                    <p-select [options]="summaryTypeList" optionLabel="label" optionValue="value"
                      [ngModel]="section.get('summary_row_type')?.value"
                      (ngModelChange)="section.get('summary_row_type')?.setValue($event)" appendTo="body"
                      [resetFilterOnHide]="true" placeholder="">
                    </p-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>

  <div class="card-ui empty-state-card" *ngIf="sections.controls.length === 0">
    <div class="empty-state-content">
      <i class="fas fa-layer-group"></i>
      <p>No sections yet</p>
      <button type="button" class="btn-primary-save" (click)="addSection()" [disabled]="!formName">
        <i class="fas fa-plus"></i> Add Section
      </button>
    </div>
  </div>

  <div class="action-bar">
    <button class="btn-secondary" (click)="resetForm()">
      <i class="fas fa-undo-alt"></i> Reset
    </button>
    <button class="btn-primary-save" (click)="submitConfig()" [disabled]="!canSubmit()">
      <i class="fas fa-check-circle"></i> Save
    </button>
  </div>
</div>

<div class="modal-overlay" *ngIf="showDeleteDialog" (click)="showDeleteDialog = false">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h5>Delete Configuration?</h5>
      <button class="modal-close" (click)="showDeleteDialog = false">×</button>
    </div>
    <div class="modal-body">
      <p>This action cannot be undone. The data will be permanently removed.</p>
    </div>
    <div class="modal-footer">
      <button class="btn-cancel-secondary" (click)="showDeleteDialog = false">Cancel</button>
      <button class="btn-danger-delete" (click)="confirmDelete()">Delete</button>
    </div>
  </div>
</div>

<div class="alert-message" [class.show]="successMessage || errorMessage" [class.success]="successMessage"
  [class.error]="errorMessage">
  <i class="fas" [class.fa-check-circle]="successMessage" [class.fa-exclamation-circle]="errorMessage"></i>
  <span *ngIf="errorMessage">{{ errorMessage }}</span>
  <span *ngIf="successMessage">{{ successMessage }}</span>
  <i class="fas fa-times close-alert" (click)="successMessage = ''; errorMessage = ''"></i>
</div>

<button class="fab-circle-btn" *ngIf="selectedForm && showReportConfig" (click)="openInfoDialog()">
  <img src="../../assets/img/f2.png" alt="" style="width: 25px;height: 25px;">
</button>

<div class="fab-dialog-overlay" *ngIf="showInfoDialog">
  <div class="fab-dialog-content">
    <div class="fab-dialog-header">
      <h5>Report Formula Configuration</h5>
      <div class="cancel-formula-dialog" (click)="closeSectionFormula()">
        <i class="fa-solid fa-xmark"></i>
      </div>
    </div>
    <div class="fab-dialog-body">
      <p-accordion [multiple]="true" [(value)]="accordionVal">
        <p-accordion-panel value="1">
          <p-accordion-header>Formula List</p-accordion-header>
          <p-accordion-content>
            <div class="formula-list">
              <div class="formula-card"
                *ngFor="let formula of sectionFormulas.controls; let f = index; trackBy: trackByFormula">
                <div class="formula-card-header">
                  <span class="formula-card-title">Formula {{ f + 1 }}</span>
                  <button type="button" class="row-delete-btn" (click)="removeSectionFormula(f)">
                    <i class="fas fa-trash"></i>
                  </button>
                </div>
                <div>
                  <input type="text" class="custom-input" [ngModel]="formula.get('formula_title')?.value"
                    (ngModelChange)="formula.get('formula_title')?.setValue($event)" placeholder="Formula title">
                </div>
                <div style="display: flex; flex-direction: row; gap: 10px;">
                  <div class="form-field-group">
                    <label>Section-1</label>
                    <p-select [options]="formSectionList" optionLabel="section_name" optionValue="section_id"
                      [ngModel]="formula.get('section_1')?.value"
                      (ngModelChange)="formula.get('section_1')?.setValue($event)" appendTo="body" [showClear]="true"
                      [resetFilterOnHide]="true" [style]="{ width: '100%' }" placeholder="Select Section">
                    </p-select>
                  </div>
                  <div class="form-field-group">
                    <label>Operator-1</label>
                    <p-select [options]="operatorList" optionLabel="label" optionValue="value"
                      [ngModel]="formula.get('operator_1')?.value"
                      (ngModelChange)="formula.get('operator_1')?.setValue($event)" appendTo="body" [showClear]="true"
                      [resetFilterOnHide]="true" [style]="{ width: '100%' }" placeholder="Select Operator">
                    </p-select>
                  </div>
                </div>
                <div style="display: flex; flex-direction: row; gap: 10px;">
                  <div class="form-field-group">
                    <label>Section-2</label>
                    <p-select [options]="formSectionList" optionLabel="section_name" optionValue="section_id"
                      [ngModel]="formula.get('section_2')?.value"
                      (ngModelChange)="formula.get('section_2')?.setValue($event)" appendTo="body" [showClear]="true"
                      [resetFilterOnHide]="true" [style]="{ width: '100%' }" placeholder="Select Section">
                    </p-select>
                  </div>
                  <div class="form-field-group">
                    <label>Operator-2</label>
                    <p-select [options]="operatorList" optionLabel="label" optionValue="value"
                      [ngModel]="formula.get('operator_2')?.value"
                      (ngModelChange)="formula.get('operator_2')?.setValue($event)" appendTo="body" [showClear]="true"
                      [resetFilterOnHide]="true" [style]="{ width: '100%' }" placeholder="Select Operator">
                    </p-select>
                  </div>
                </div>
              </div>
              <div *ngIf="sectionFormulas.controls.length === 0" class="empty-placeholder">
                No formulas configured
              </div>
            </div>
            <div style="display: flex; flex-direction: row-reverse; gap: 10px; margin-top: 10px;">
              <button class="btn-primary-save" (click)="saveSectionFormula()" [disabled]="!this.sectionFormulas.valid">
                <i class="fas fa-save"></i> Save
              </button>
              <button class="btn-cancel-secondary" (click)="closeSectionFormula()">
                <i class="fa-solid fa-circle-xmark"></i> Cancel
              </button>
              <button class="btn-primary-save" (click)="addSectionFormula()" [disabled]="!this.sectionFormulas.valid">
                <i class="fas fa-plus"></i> Add Formula
              </button>
            </div>
          </p-accordion-content>
        </p-accordion-panel>
      </p-accordion>
    </div>
  </div>
</div>